import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import OrderService from 'services/order';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import ModalService from 'services/modal';
import dayjs from 'dayjs';
import Http from 'services/http2';
import Big from 'big.js';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  }
});
/**
 * 交料通知详情
 */
function DeliveryChangeDetail(props) {
  const Config = {
    purchase: {
      title: '交料通知单详情',
      apiPath: '/acnotify/getDetail',
      publishApiPath: '/acnotify/publish',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        { mainKey: 'B02_Acn_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      idField: 'acnXkNo',
      wfmCode: '1016'
    },
    sale: {
      title: '客户交料通知单详情',
      apiPath: '/cAcnotify/getDetail',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      answerApiPath: '/cAcnotify/answer',
      arrEnumField: [
        { mainKey: 'B02_Acn_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      idField: 'acnXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [showReply, setShowReply] = useState(false);
  const [operateType, setOperateType] = useState(1);
  const [currReply, setCurrReply] = useState({
    vExpectedDate: '',
    vPurchaseQty: '',
    vTaxPrice: 0,
    vPrice: 0,
    isContainTax: '',
    vRemark: ''
  });
  const [isReplyPrice, setIsReplyPrice] = useState(false);
  const [currItem, setCurrItem] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    //重新组装答交信息，便于模板显示
    if (data.customerAnswerChangeNoticeAnswer) {
      //有答交信息
      let replyList =
        data.customerAnswerChangeNoticeAnswer
          .customerAnswerChangeNoticeAnswerLineList || [];
      data.lineList.forEach(item => {
        let arr = [];
        item.hasDiff = false; //是否有差异
        replyList.forEach(reply => {
          if (reply.lineNo === item.lineNo) {
            if (typeof reply.diffReason === 'string') {
              reply.diffReason = reply.diffReason.split(','); //B02_Answer_Diff  1单价差异，2数量差异，3交期差异
              item.hasDiff = true; //是否有差异
            } else {
              reply.diffReason = [];
            }
            arr.push(reply);
          }
        });
        item.replyList = arr;

        //操作类型  1:同意; 2:确认
        if (
          Array.isArray(item.replyList) &&
          item.replyList.some(reply => reply.isAgreeDiff)
        ) {
          setOperateType(2);
        }
      });
    }

    let arrAnswerLineNo = [];
    if (data.customerAnswerChangeNoticeAnswer) {
      //已答交
      arrAnswerLineNo =
        data.customerAnswerChangeNoticeAnswer.customerAnswerChangeNoticeAnswerLineList.map(
          item => item.lineNo
        );
    }
    data.lineList.forEach(item => {
      if (arrAnswerLineNo.indexOf(item.lineNo) === -1) {
        //未达交过项次（新订单或变更后新增）
        let obj = { subLineNo: 1 };
        Util.copyPropsBySchema(obj, item, [
          'lineNo',
          'productCode',
          ['noticeQty', 'vPurchaseQty'],
          ['noticeExpectedDate', 'vExpectedDate']
        ]);
        item.replyList = [obj];
      }
    });

    let list = data.lineList || [];
    list.forEach(item => {
      if (item.poLine) {
        EnumService.getValue('B02_Pol_Status', item.poLine.status).then(
          value => {
            item.poLine.statusName = value;
            forceUpdate();
          }
        );
        Util.genExtendFields(item.poLine);
      }
      if (
        Array.isArray(item.answerLineList) &&
        item.answerLineList.length === 1
      ) {
        item.isSingle = true;
      }
    });
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  //发送
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    OrderService.publishAcnOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //确认答交
  function deliveryChangeConfirm() {
    let hasError = false;
    let errorMsg = '答交日期不能为空';
    let validate = (item, reply) => {
      let replyDates =
        item.replyList.map(val =>
          dayjs(val.vExpectedDate).format('YYYYMMDD')
        ) || [];
      if (hasError) {
        return;
      }
      if (reply.vExpectedDate === '') {
        hasError = true;
      } else if (Util.isDuplicated(replyDates)) {
        hasError = true;
        errorMsg = '答交日期不允许重复';
      } else if (reply.isChanged && Util.isEmpty(reply.vRemark)) {
        hasError = true;
        errorMsg = '答交有差异，备注不能为空';
      }
    };
    let arr = [];
    let customerAnswerChangeNoticeAnswerLineList = [];

    detail.lineList.forEach(item => {
      if (item.replyList) {
        item.replyList.forEach(reply => {
          if (Array.isArray(reply.diffReason)) {
            reply.diffReason = reply.diffReason.join(',');
          }
          reply.lineNo = item.lineNo;
          reply.acnXkNo = item.acnXkNo;
          reply.productCode = item.productCode;
          arr.push(reply);
          validate(item, reply);
        });
      }
    });

    customerAnswerChangeNoticeAnswerLineList = arr.map(row => {
      return {
        id: row.id || null,
        companyCode: companyCode,
        acnXkNo: self.id,
        lineNo: row.lineNo,
        subLineNo: row.subLineNo,
        productCode: row.productCode,
        vPurchaseQty: row.vPurchaseQty,
        vExpectedDate: row.vExpectedDate,
        vStatus: row.vStatus,
        diffReason: row.diffReason,
        rejectReason: row.rejectReason,
        vRemark: row.vRemark
      };
    });

    if (hasError) {
      ModalService.showError(errorMsg, dispatch);
      return;
    }
    let postbody = getPostbody(config.answerApiPath);
    postbody.action = 'confirm';
    postbody.customerCode = detail.customerCode;
    postbody.customerXkUniqueCode = detail.customerXkUniqueCode;
    postbody.customerAnswerChangeNoticeAnswerLineList =
      customerAnswerChangeNoticeAnswerLineList;
    OrderService.answerAcnOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //编辑答交信息
  // type 1,编辑  2,删除  3,新增
  function handleEdit(reply, type, item) {
    reply.isContainTax = item.isContainTax;
    reply.purchaseUnitName = item.purchaseUnitName;
    reply.vExpectedDateShow =
      formatDate(reply.vExpectedDate, 'YYYY-MM-DD') || '';
    if (type === 1) {
      for (const key in reply) {
        if (
          Object.hasOwnProperty.call(reply, key) &&
          [
            'vExpectedDate',
            'vPurchaseQty',
            'vTaxPrice',
            'vPrice',
            'isContainTax',
            'vRemark'
          ].includes(key)
        ) {
          reply[key] = reply[key] || '';
          if (key === 'vTaxPrice' || key === 'vPrice') {
            reply[key] = reply[key] || 0;
          }
        }
      }
    } else if (type === 3) {
      reply = { subLineNo: 0 };
      let n = Big(0); //答交总数量
      item.replyList?.forEach(row => {
        if (row.subLineNo > reply.subLineNo) {
          reply = Object.assign({}, row);
        }
        if (Util.isBig(row.vPurchaseQty)) {
          n = n.plus(row.vPurchaseQty);
        }
      });
      //自动根据数量差额填写
      reply.vPurchaseQty = n.gte(item.noticeQty) ? 0 : item.noticeQty - n;
      reply.vLineAmount =
        reply.vPrice *
        reply.vPurchaseQty *
        (item.valuationQty / item.noticeQty);
      reply.vTaxLineAmount =
        reply.vTaxPrice *
        reply.vPurchaseQty *
        (item.valuationQty / item.noticeQty);
      reply.subLineNo += 1;
      delete reply.id;
    }
    setCurrItem(item);
    setCurrReply(reply);
    setShowReply(true);
    setOperateType(type);
  }

  function handleOk() {
    currReply.isChanged =
      dayjs(currReply.vExpectedDate).format('YYYYMMDD') !==
        dayjs(currItem.noticeExpectedDate).format('YYYYMMDD') ||
      Number(currReply.vPurchaseQty) !== currItem.noticeQty;

    let hasError = false;
    let errorMsg = '答交日期不能为空';
    let validate = (item, reply) => {
      let replyDates =
        lineList.map(val => dayjs(val.vExpectedDate).format('YYYYMMDD')) || [];
      if (hasError) {
        return;
      }
      if (reply.vExpectedDate === '') {
        hasError = true;
      } else if (Util.isDuplicated(replyDates)) {
        hasError = true;
        errorMsg = '答交日期不允许重复';
      } else if (reply.isChanged && Util.isEmpty(reply.vRemark)) {
        hasError = true;
        errorMsg = '答交有差异，备注不能为空';
      }
    };
    let lineList = [];
    currItem.replyList.forEach(reply => {
      reply.productName = currItem.productName;
      if (reply.id !== currReply.id) {
        lineList.push(reply);
      } else {
        lineList.push(currReply);
      }
    });

    if (operateType === 2) {
      let index = currItem.replyList.findIndex(
        item => item.id === currReply.id
      );
      let currItemObj = Util.clone(currItem);
      currItemObj.replyList.splice(index, 1);
      lineList = currItemObj.replyList;
    }
    if (operateType === 3) {
      lineList.push(currReply);
    }
    validate(currItem, currReply);
    if (hasError && operateType !== 2) {
      ModalService.showError(errorMsg, dispatch);
      return;
    }
    lineList.forEach(item => {
      if (Array.isArray(item.diffReason)) {
        item.diffReason = item.diffReason.join(',');
      }
    });
    let customerAnswerChangeNoticeAnswerLineList = [];
    customerAnswerChangeNoticeAnswerLineList = lineList.map(row => {
      return {
        id: row.id || null,
        companyCode: companyCode,
        acnXkNo: self.id,
        lineNo: row.lineNo,
        subLineNo: row.subLineNo,
        productCode: row.productCode,
        vPurchaseQty: row.vPurchaseQty,
        vExpectedDate: row.vExpectedDate,
        vStatus: row.vStatus,
        diffReason: row.diffReason,
        rejectReason: row.rejectReason,
        vRemark: row.vRemark
      };
    });
    let postbody = {
      customerAnswerChangeNoticeAnswerLineList:
        customerAnswerChangeNoticeAnswerLineList,
      acnXkNo: self.id,
      action: 'save',
      customerCode: detail.customerCode,
      customerXkUniqueCode: detail.customerXkUniqueCode,
      companyCode: companyCode,
      apiPath: '/cAcnotify/answer'
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        handleClose();
        self.getDetail();
        setCurrReply({
          vExpectedDate: '',
          vPurchaseQty: '',
          vTaxPrice: 0,
          vPrice: 0,
          isContainTax: '',
          vRemark: ''
        });
      } else if (response.errorMsg) {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  /**
   * 检查答交数据和订单数据是否有差异。有差异时，提交数据需要校验备注字段必填。
   *
   * 1. 日期为同一天即为无差异
   * 2. 如果操作人无价格权限或采购方设置了不显示价格，视为无差异。
   */
  function checkReplyData() {
    detail.lineList.forEach(item => {
      let isSingle = item.replyList.length === 1;
      item.replyList.forEach(reply => {
        if (isSingle) {
          reply.isChanged =
            dayjs(reply.vExpectedDate).format('YYYYMMDD') !==
              dayjs(item.noticeExpectedDate).format('YYYYMMDD') ||
            Number(reply.vPurchaseQty) !== item.noticeQty;
        } else {
          //分批答交
          reply.isChanged = true;
        }
      });
    });
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = obj.acnXkNo,
      xkNo = obj.acnXkNo,
      lineNo = obj.lineNo,
      cCode = obj[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }
  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      acnXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  function handleClose() {
    setShowReply(false);
  }

  function handleDateChange(event) {
    let detailObj = Util.clone(currReply);
    if (event.target.value) {
      detailObj.vExpectedDate = event.target.valueAsNumber - 28800000;
      detailObj.vExpectedDateShow =
        formatDate(detailObj.vExpectedDate, 'YYYY-MM-DD') || '';
    }
    setCurrReply(detailObj);
  }

  function handleChange(event, key) {
    let detailObj = Util.clone(currReply);
    let val = event.target.value;
    detailObj[key] = val;
    setCurrReply(detailObj);
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">交料通知单号</span>
                  <div className="field-value">{detail.acnXkNo}</div>
                </li>
                {self.isPurchase && (
                  <li>
                    <span className="field-label">供应商</span>
                    <div className="field-value">{detail.innerVendorName}</div>
                  </li>
                )}
                {detail.attachCount > 0 &&
                  (!self.isPurchase || User.checkAuth('10010502')) && (
                    <li>
                      <span className="field-label">附件</span>
                      <div className="field-value">
                        <span
                          className="attachment"
                          onClick={() => showFileList(62, detail)}
                        >
                          {detail.attachCount}个附件
                          <i className="icon-attachment"></i>
                        </span>
                      </div>
                    </li>
                  )}
                <li>
                  <span className="field-label">发布时间</span>
                  <div>
                    {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                  </div>
                </li>
                <li>
                  <span className="field-label">发布人</span>
                  <div className="field-value">{detail.publishName}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('acn', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">送货状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('dcs', detail.deliveryStatus)
                      }
                    >
                      {detail.deliveryStatusName}
                    </span>
                  </div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        {/*交料通知单明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>交料通知明细</label>
            </div>
            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span className="lineNo">项次 {item.lineNo}</span>
                    {!self.isPurchase &&
                      User.checkAuth('20010402') &&
                      [1, 7, 8].includes(detail.status) && (
                        <div className="more">
                          <i
                            className="icon-edit"
                            onClick={() => {
                              handleEdit({}, 3, item);
                            }}
                          ></i>
                        </div>
                      )}
                  </div>

                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格（特征值）</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                    {item.poLine.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.poLine.printExtendFields}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">
                        {self.isPurchase ? '采购单号' : '客户订单'}
                      </span>
                      <div className="field-value">{item.poErpNo}</div>
                    </li>
                    <li>
                      <span className="field-label">订单项次</span>
                      <div className="field-value">{item.poLineNo}</div>
                    </li>
                    <li>
                      <span className="field-label">行状态</span>
                      <div className="field-value">
                        <span
                          className={
                            'u-sign ' +
                            CommonFns.getStatusClass('bool', item.status)
                          }
                        >
                          {(item.status === 1 ? '正常' : '作废') || '--'}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">订单状态</span>
                      <div className="field-value">
                        {item.poLine?.statusName}
                      </div>
                    </li>
                    {item.isSingle && (
                      <li>
                        <span className="field-label">采购交期</span>
                        <div className="field-value">
                          {formatDate(
                            item.answerLineList[0].vExpectedDate,
                            'YYYY-MM-DD'
                          )}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">待交数量</span>
                      <div className="field-value">
                        {formatNumber(
                          item.totalUnDeliveryQty,
                          decimalPlace.QTY
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单位</span>
                      <div className="field-value">
                        {item.poLine?.purchaseUnitName}
                        {item.poLine?.purchaseUnitName &&
                          item.poLine?.purchaseUnitName !==
                            item.poLine?.purchaseUnitCode && (
                            <span>/{item.poLine.purchaseUnitCode}</span>
                          )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">通知交期</span>
                      <div className="field-value">
                        {formatDate(item.noticeExpectedDate, 'YYYY-MM-DD')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">通知数量</span>
                      <div className="field-value">
                        {formatNumber(item.noticeQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单位</span>
                      <div className="field-value">
                        {item.poLine?.purchaseUnitName}
                        {item.poLine?.purchaseUnitName &&
                          item.poLine?.purchaseUnitName !==
                            item.poLine?.purchaseUnitCode && (
                            <span>/{item.poLine.purchaseUnitCode}</span>
                          )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">通知交期</span>
                      <div className="field-value">
                        {formatDate(item.noticeExpectedDate, 'YYYY-MM-DD')}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{item.remark}</div>
                    </li>
                  </ul>
                  <div
                    className={
                      (!self.isPurchase && !item.replyList) ||
                      (self.isPurchase && detail.orderStatus === 1)
                        ? 'order-detail-more hide'
                        : 'order-detail-more'
                    }
                  >
                    {!item.replyList ||
                      (item.replyList.length === 1 &&
                        item.replyList[0].vStatus !== 2)}
                    {item.replyList &&
                      item.replyList.map((reply, i) => (
                        <ul
                          className="field-list"
                          key={String(reply.id) + i + 1}
                        >
                          {!self.isPurchase &&
                            User.checkAuth('20010402') &&
                            [1, 7, 8].includes(detail.status) && (
                              <div className="order-detail-item">
                                <span
                                  className="icons"
                                  style={{
                                    top: '5px',
                                    backgroundColor: 'rgb(254, 247, 229)'
                                  }}
                                >
                                  <EditIcon
                                    className="edit"
                                    onClick={() => handleEdit(reply, 1, item)}
                                  />
                                  {!self.isPurchase && (
                                    <HighlightOffIcon
                                      className="delete"
                                      onClick={() => handleEdit(reply, 2, item)}
                                    />
                                  )}
                                </span>
                              </div>
                            )}
                          <li
                            className={
                              reply.diffReason?.indexOf('3') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">答交时间</span>
                            <div className="field-value">
                              {formatDate(reply.vExpectedDate)}
                            </div>
                          </li>
                          <li
                            className={
                              reply.diffReason?.indexOf('2') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">答交数量</span>
                            <div className="field-value">
                              {formatNumber(
                                reply.vPurchaseQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}{' '}
                              {item.purchaseUnitName}
                            </div>
                          </li>
                          <li
                            className={
                              reply.diffReason?.indexOf('1') > -1 ? 'red' : ''
                            }
                          >
                            <span className="field-label">备注</span>
                            <div className="field-value">{reply.vRemark}</div>
                          </li>
                        </ul>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <Dialog
        open={showReply}
        onClose={() => handleClose()}
        classes={{ paper: props.classes.paper }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {operateType === 1
            ? '编辑答交信息'
            : operateType === 2
            ? '删除答交信息'
            : '新增答交信息'}
        </DialogTitle>
        <DialogContent>
          <ul>
            <li className="dialog order-detail-item">
              <div className="line">
                <span>项次：</span>
                <div>{currReply.lineNo}</div>
              </div>
              <div className="line">
                <span>物料编码：</span>
                <div>{currReply.productCode}</div>
              </div>
              <div className="line">
                <span>答交时间：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <form noValidate>
                      <TextField
                        value={currReply.vExpectedDateShow || ''}
                        onChange={e => handleDateChange(e)}
                        id="date"
                        type="date"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </form>
                  ) : (
                    <span>{formatDate(currReply.vExpectedDate)}</span>
                  )}
                </div>
              </div>
              <div className="line">
                <span>答交数量：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <input
                      type="text"
                      value={currReply.vPurchaseQty}
                      onChange={e => handleChange(e, 'vPurchaseQty')}
                    />
                  ) : (
                    <span>
                      {formatNumber(
                        currReply.vPurchaseQty,
                        decimalPlace.Quantity_Decimal_Place
                      )}{' '}
                      {currReply.purchaseUnitName}
                    </span>
                  )}
                </div>
              </div>
              <div className="line">
                <span>备注：</span>
                <div>
                  {[1, 3].includes(operateType) ? (
                    <input
                      type="text"
                      value={currReply.vRemark}
                      onChange={e => handleChange(e, 'vRemark')}
                    />
                  ) : (
                    <span>{currReply.vRemark}</span>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => handleClose()} color="primary">
            取消
          </MuiButton>
          {[1, 3].includes(operateType) && (
            <MuiButton onClick={() => handleOk()} color="primary">
              确定
            </MuiButton>
          )}
          {operateType === 2 && (
            <MuiButton onClick={() => handleOk()} color="secondary">
              确认删除
            </MuiButton>
          )}
        </DialogActions>
      </Dialog>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10010505') &&
            [0, 2, 9].includes(detail.status) &&
            workflow.data &&
            workflow.data['advice_note_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
        </div>
      )}
      {!self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('20010402') && [1, 7, 8].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                deliveryChangeConfirm();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认答交
            </Button>
          )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

DeliveryChangeDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DeliveryChangeDetail));
